import * as Yup from 'yup'

export const ISSUE_FORM_VALIDATION_SCHEMA = Yup.object().shape({
  image: Yup.mixed().required('Je potřeba vložit fotku'),
  room: Yup.object().shape({
    value: Yup.string().required('Je potřeba vybrat místnost'),
  }),
})
